import { xyzAutoSignalsPicking } from '..';
import { formatZones } from './util/formatZone';
export function xyzAutoZonesPicking(spectraData, options) {
    const signals = xyzAutoSignalsPicking(spectraData, options);
    return formatZones(signals);
}
//# sourceMappingURL=xyzAutoZonesPicking.js.map